import { adminCall, adminGet } from '../../api/adminCall';

export async function adminListSupportTickets({ status = 'all', pageSize = 100 } = {}) {
  const params = new URLSearchParams();
  params.set('status', status);
  params.set('pageSize', String(pageSize));
  const result = await adminGet(`/api/admin/support-tickets?${params.toString()}`);
  return result.tickets || [];
}

export async function adminGetSupportTicket({ companyId, ticketId }) {
  const result = await adminGet(
    `/api/admin/support-tickets/${encodeURIComponent(companyId)}/${encodeURIComponent(ticketId)}`
  );
  return result.ticket || null;
}

export async function adminListSupportTicketMessages({ companyId, ticketId, pageSize = 200 } = {}) {
  const params = new URLSearchParams();
  params.set('pageSize', String(pageSize));
  const result = await adminGet(
    `/api/admin/support-tickets/${encodeURIComponent(companyId)}/${encodeURIComponent(ticketId)}/messages?${params.toString()}`
  );
  return result.messages || [];
}

export async function adminAddSupportTicketMessage({ companyId, ticketId, body, authorFirstName } = {}) {
  return adminCall(
    `/api/admin/support-tickets/${encodeURIComponent(companyId)}/${encodeURIComponent(ticketId)}/messages`,
    { body, authorFirstName }
  );
}

export async function adminUpdateSupportTicketStatus({ companyId, ticketId, status } = {}) {
  return adminCall(
    `/api/admin/support-tickets/${encodeURIComponent(companyId)}/${encodeURIComponent(ticketId)}/status`,
    { status }
  );
}

export async function adminUpdateSupportTicketAssignment({ companyId, ticketId, assignedTo } = {}) {
  return adminCall(
    `/api/admin/support-tickets/${encodeURIComponent(companyId)}/${encodeURIComponent(ticketId)}/assignment`,
    { assignedTo }
  );
}

export async function adminCountSupportTickets({ status = 'open' } = {}) {
  const params = new URLSearchParams();
  params.set('status', status);
  const result = await adminGet(`/api/admin/support-tickets/count?${params.toString()}`);
  return result;
}

export async function adminGetSupportTicketAttachmentUrl({ storagePath }) {
  if (!storagePath) throw new Error('storagePath is required');
  const params = new URLSearchParams({ path: storagePath });
  return adminGet(`/api/admin/files/url?${params.toString()}`);
}
